import * as React from 'react';

function SvgTrackCanceled() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.49992 15.8333C6.00867 15.8333 3.16659 12.9912 3.16659 9.49992C3.16659 6.00867 6.00867 3.16659 9.49992 3.16659C12.9912 3.16659 15.8333 6.00867 15.8333 9.49992C15.8333 12.9912 12.9912 15.8333 9.49992 15.8333ZM9.49992 1.58325C5.122 1.58325 1.58325 5.122 1.58325 9.49992C1.58325 13.8778 5.122 17.4166 9.49992 17.4166C13.8778 17.4166 17.4166 13.8778 17.4166 9.49992C17.4166 5.122 13.8778 1.58325 9.49992 1.58325ZM11.5503 6.33325L9.49992 8.38367L7.4495 6.33325L6.33325 7.4495L8.38367 9.49992L6.33325 11.5503L7.4495 12.6666L9.49992 10.6162L11.5503 12.6666L12.6666 11.5503L10.6162 9.49992L12.6666 7.4495L11.5503 6.33325Z"
        fill="black"
      />
    </svg>

  );
}

export default SvgTrackCanceled;
